import React from 'react';
import ReactDOM from 'react-dom';
import { fetchRuntimeConfig } from './utils/runtimeConfig';

/**
 * Boots the application: fetches runtime-config.json (so per-stage values are available
 * before any module imports `./config`), configures Amplify, then renders <App />.
 * Imports of modules that read `config` at evaluation time are dynamic so they evaluate
 * after `window.__runtimeConfig__` is set.
 */
export default async function bootstrap(): Promise<void> {
  const runtime = await fetchRuntimeConfig();
  // eslint-disable-next-line no-underscore-dangle
  if (runtime) window.__runtimeConfig__ = runtime;

  const { Amplify } = await import('aws-amplify');
  const { default: config } = await import('./config');
  const { default: App } = await import('./App');
  const { configureAxios } = await import('./api/httpInterceptors');
  const { initRum } = await import('./utils/rum');

  Amplify.configure({
    Auth: {
      identityPoolId: config.cognitoConfig.identityPoolId,
      region: config.cognitoConfig.region,
      userPoolId: config.cognitoConfig.userPoolId,
      userPoolWebClientId: config.cognitoConfig.userPoolWebClientId,
      cookieStorage: {
        domain: window.location.hostname,
        path: '/',
        expires: 365,
        secure: true,
        sameSite: 'lax',
      },
      oauth: {
        domain: config.cognitoConfig.domain,
        scope: ['openid'],
        redirectSignIn: config.cognitoConfig.redirectUrl,
        redirectSignOut: config.cognitoConfig.redirectUrl.replace(
          '/auth',
          '/login'
        ),
        responseType: 'code',
      },
    },
  });

  configureAxios();
  initRum();

  ReactDOM.render(<App />, document.getElementById('root'));
}
